export const formatDate = (date) => {
  const toDate = date.split('/');

  const formattedDate = new Date(+toDate[2], toDate[1] - 1, +toDate[0]);

  return formattedDate.getTime();
};
